<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('applicant_assessment.applicant_assessment') }} {{ $t('globalTrans.search') }}</h4>
        </template>
        <template v-slot:body>
            <b-row>
                <b-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="year"
                    >
                      <template v-slot:label>
                        {{$t('globalTrans.year')}}
                      </template>
                      <b-form-select
                        plain
                        v-model="search.year"
                        :options="yearList"
                        id="year"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="org_id"
                    >
                    <template v-slot:label>
                    {{$t('ds_config.organization')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.org_id"
                        :options="orgList"
                        id="org_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :disabled="$store.state.Auth.authUser.role_id === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="institute_type"
                    >
                    <template v-slot:label>
                    {{$t('ds_config.institute_type')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.office_type_id"
                        :options="officeTypeList"
                        id="office_type_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="institute_name"
                    >
                    <template v-slot:label>
                    {{$t('ds_config.institute_name')}}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.office_id"
                        :options="officeList"
                        id="office_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
        </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('applicant_assessment.applicant_assessments')}} {{ $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:head(check)>
                        <b-form-checkbox
                            style="display: table-cell"
                            class="col-form-label-sm font-weight-bold mb-0"
                            name="checked"
                            v-model="selectAll"
                            @change="checkAll"
                            :value=true
                            :unchecked-value=false
                        >
                        </b-form-checkbox>
                    </template>
                    <template v-slot:cell(check)="data">
                            <!-- CheckBox -->
                        <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group v-model="selectedStudents" style="margin-top: 5px" :aria-describedby="ariaDescribedby">
                                <b-form-checkbox :value="data.item.admission_id" style="margin-right: 0"></b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </template>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(year)="data">
                      <span class="capitalize">{{ $n(data.item.year, { useGrouping: false }) }}</span>
                    </template>
                    <template v-slot:cell(mobile_no)="data">
                      <span class="capitalize">{{ data.item.admission.mobile_no | mobileNumber }}</span>
                    </template>
                    <template v-slot:cell(app_status)="data">
                        <span v-if="data.item" class="badge badge-danger">{{$t('globalTrans.pending')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button title="View Details" v-b-modal.modal-detail variant=" iq-bg-success mr-1 mb-1" size="sm" @click="details(data.item)"><i class="ri-eye-fill m-0"></i></b-button>
                    </template>
                    <template #custom-foot="">
                      <b-tr>
                          <b-th colspan="6"></b-th>
                          <b-th colspan="4" class="text-center">
                              <b-button v-if="$store.state.Auth.authUser.ssoLogin" class="mr-1 blink_me" variant="btn btn-xs btn-success" size="sm" @click="finalSave()" :disabled="selectedStudents.length > 0 ? false : true">
                                <i class="fa fa-forward"></i> {{$t('globalTrans.to_nothi')}}
                              </b-button>
                              <button v-b-modal.modal-refer class="btn btn-success btn-sm mr-1" :title="$t('applicant_assessment.refer')" :disabled="selectedStudents.length > 0 ? false : true">
                                  <i class="fas fa-list"></i>{{ $t('applicant_assessment.refer') }}
                              </button>
                              <button @click="approveApplicant(status = 1)" class="btn btn-primary btn-sm mr-1" :title="$t('globalTrans.approve')" :disabled="selectedStudents.length > 0 ? false : true">
                                  <i class="fas fa-list"></i>{{ $t('globalTrans.approve') }}
                              </button>
                              <button @click="approveApplicant(status = 3)" class="btn btn-danger btn-sm" :title="$t('globalTrans.reject')" :disabled="selectedStudents.length > 0 ? false : true">
                                  <i class="fas fa-list"></i>{{ $t('globalTrans.reject') }}
                              </button>
                          </b-th>
                      </b-tr>
                  </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="xl" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId" :key="editItemId" />
    </b-modal>
    <b-modal id="modal-refer" size="md" :title="$t('globalTrans.remarks')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
          <b-container fluid>
            <b-overlay :show="referLoading">
              <b-form @submit.prevent="handleSubmit(referToSubmit)" @reset.prevent="reset" autocomplete="off">
                <b-row>
                  <b-col sm="12">
                    <ValidationProvider name="Remarks" vid="remarks" rules="required">
                      <b-form-group
                        label-for="remarks"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('globalTrans.remarks')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-textarea
                        plain
                        v-model="remarks"
                        id="remarks"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      </b-form-textarea>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                  </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="text-right">
                  <b-col>
                    <b-button type="submit" variant="success" class="mr-2 btn-sm">{{ $t('globalTrans.submit') }}</b-button>
                    <b-button variant="danger" class="btn-sm" @click="$bvModal.hide('modal-refer')">{{ $t('globalTrans.cancel') }}</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-overlay>
          </b-container>
        </ValidationObserver>
    </b-modal>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import DetailModal from '../applicant-assessment/DetailModal'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { applicantAssessmentListApi, approveApplicantApi, pendingNothiApplicantApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    DetailModal,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      referLoading: false,
      editItemId: 0,
      selectAll: false,
      selectedStudents: [],
      search: {
        year: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        isAapproval: 1
      },
      officeTypeList: [],
      officeList: [],
      remarks: ''
    }
  },
  computed: {
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    yearList: function () {
      return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item, text: this.$n(item, { useGrouping: false }) }
        } else {
          return item
        }
      })
    },
    getTransportList () {
        return this.$store.state.DisabilitySchoolService.commonObj.transportNameList.map(item => {
            if (this.$i18n.locale === 'bn') {
                return { value: item.value, text: item.text_bn }
            } else {
                return { value: item.value, text: item.text_en }
            }
        })
    },
    detailTitle () {
      return this.$t('applicant_assessment.applicant_assessments') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
            const labels = [
                { label: 'check', class: 'text-center' },
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('globalTrans.year'), class: 'text-left' },
                { label: this.$t('globalTrans.organization'), class: 'text-left' },
                { label: this.$t('ds_institute_management.institute_type'), class: 'text-left' },
                { label: this.$t('ds_institute_management.institute_name'), class: 'text-left' },
                { label: this.$t('admission_management.applicant_mobile'), class: 'text-left' },
                { label: this.$t('globalTrans.status'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]
            let keys = []
            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'check' },
                    { key: 'index' },
                    { key: 'year' },
                    { key: 'org_bn' },
                    { key: 'office_type_bn' },
                    { key: 'office_bn' },
                    { key: 'mobile_no' },
                    { key: 'app_status' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'check' },
                    { key: 'index' },
                    { key: 'year' },
                    { key: 'org' },
                    { key: 'office_type' },
                    { key: 'office' },
                    { key: 'mobile_no' },
                    { key: 'app_status' },
                    { key: 'action' }
                ]
            }
            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    },
  watch: {
    'search.org_id': function () {
        this.getOfficeTypeList()
    },
    'search.office_type_id': function () {
        this.getOfficeList()
    },
    selectedStudents: function () {
      if (this.selectedStudents.length === this.listData.length) {
        this.selectAll = true
      }

      if (this.selectedStudents.length < this.listData.length) {
        this.selectAll = false
      }
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getOfficeTypeList()
          this.getOfficeList()
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
      this.loadData()
    },
  mounted () {
  },
  methods: {
    checkAll () {
        if (this.selectAll) {
            this.selectedStudents.splice(0, this.selectedStudents.length)
            this.listData.forEach(element => this.selectedStudents.push(element.admission_id))
        } else {
            this.selectedStudents.splice(0, this.selectedStudents.length)
        }
    },
    finalSave () {
      const myItem = {
        dataArray: [],
        ids: this.selectedStudents
      }
      this.selectedStudents.map(el => {
        const Obj = this.listData.find(item => item.admission_id === el)
        myItem.dataArray.push(Obj)
      })
      this.toggleStatusCustom2(disabilitySchoolServiceBaseUrl, pendingNothiApplicantApi, myItem)
    },
    toggleStatusCustom2 (baseUrl, uri, item) {
      window.vm.$swal({
        title: window.vm.$t('globalTrans.are_you_sure_forward_to_nothi'),
        showCancelButton: true,
        confirmButtonText: window.vm.$t('globalTrans.yes'),
        cancelButtonText: window.vm.$t('globalTrans.no'),
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeStatusCustom(baseUrl, uri, item)
        }
      })
    },
    changeStatusCustom (baseUrl, uri, item) {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.postData(baseUrl, uri, item).then(response => {
        if (response.success) {
          window.vm.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.$t('globalTrans.update_msg'),
            color: '#D6E09B'
          })
        } else {
          window.vm.$toast.error({
            title: 'Error',
            message: 'Operation failed! Please, try again.'
          })
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
      })
    },
    referToSubmit () {
      this.approveApplicant(5)
    },
    approveApplicant (status) {
      let msg = ''
      if (status === 5) {
        msg = window.vm.$t('applicant_assessment.refer_msg')
      } else if (status === 1) {
        msg = window.vm.$t('globalTrans.approveMsg')
      } else {
        msg = window.vm.$t('globalTrans.rejectMsg')
      }
        window.vm.$swal({
            title: msg,
            showCancelButton: true,
            confirmButtonText: window.vm.$t('globalTrans.yes'),
            cancelButtonText: window.vm.$t('globalTrans.no'),
            focusConfirm: false
        }).then((result) => {
            if (result.isConfirmed) {
                const myData = {
                  status: status,
                  ids: this.selectedStudents,
                  remarks: this.remarks
                }
                this.referLoading = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                const loadingState = { loading: false, listReload: true }
                RestApi.postData(disabilitySchoolServiceBaseUrl, approveApplicantApi, myData).then(response => {
                this.$store.dispatch('mutateCommonProperties', loadingState)
                    if (response.success) {
                        this.$toast.success({
                            title: this.$t('globalTrans.success'),
                            message: this.$t('globalTrans.update_msg'),
                            color: '#D6E09B'
                        })
                        this.remarks = ''
                        this.$bvModal.hide('modal-refer')
                    }
                    this.referLoading = false
                })
            }
        })
    },
    searchData () {
      this.loadData()
    },
    getOfficeTypeList () {
        if (this.search.org_id) {
            this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id)
        }
    },
    getOfficeList () {
        if (this.search.office_type_id) {
            this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id)
        }
    },
    details (item) {
      this.editItemId = item.id
    },
    edit (item) {
        this.editItemId = item
      },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(disabilitySchoolServiceBaseUrl, applicantAssessmentListApi, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
      let orgList = {}
      let officeTypeList = {}
      let officeList = {}
      const listData = data.map(item => {
        orgList = this.$store.state.orgList.find(org => org.value === item.org_id)
        officeTypeList = this.$store.state.commonObj.officeTypeList.find(officeType => officeType.value === item.office_type_id)
        officeList = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id)
        const data = {
            org: orgList !== undefined ? orgList.text_en : '',
            org_bn: orgList !== undefined ? orgList.text_bn : '',
            office_type: officeTypeList !== undefined ? officeTypeList.text_en : '',
            office_type_bn: officeTypeList !== undefined ? officeTypeList.text_bn : '',
            office: officeList !== undefined ? officeList.text_en : '',
            office_bn: officeList !== undefined ? officeList.text_bn : ''
          }
          return Object.assign({}, item, data)
      })
      return listData
    }
  }
}
</script>
<style scope='css'>
  .blink_me {
    animation: blinker 1.3s linear infinite;
    color: red;
  }
  @keyframes blinker {
    50% {
      opacity: .09;
      background-color: green;
    }
  }
</style>
